import { api } from "@/lib/api";

export const artworkApi = {
  meta: () => api.get("/artwork/meta").then((r) => r.data),
  stats: () => api.get("/artwork/stats").then((r) => r.data),
  list: (params) => api.get("/artwork/artworks", { params }).then((r) => r.data),
  get: (id) => api.get(`/artwork/artworks/${id}`).then((r) => r.data),
  create: (body) => api.post("/artwork/artworks", body).then((r) => r.data),
  updateHeader: (id, body) => api.put(`/artwork/artworks/${id}`, body).then((r) => r.data),
  addVersion: (id) => api.post(`/artwork/artworks/${id}/versions`).then((r) => r.data),
  updateVersion: (id, v, body) => api.put(`/artwork/artworks/${id}/versions/${v}`, body).then((r) => r.data),
  strikeOff: (id, v, body) => api.post(`/artwork/artworks/${id}/versions/${v}/strike-off`, body).then((r) => r.data),
  approve: (id, v, body) => api.post(`/artwork/artworks/${id}/versions/${v}/approve`, body).then((r) => r.data),
  reject: (id, v, body) => api.post(`/artwork/artworks/${id}/versions/${v}/reject`, body).then((r) => r.data),
  lock: (id, v) => api.post(`/artwork/artworks/${id}/versions/${v}/lock`).then((r) => r.data),
  productionReady: (customer_id) => api.get("/artwork/production-ready", { params: { customer_id } }).then((r) => r.data),
};

export const ART_STATUS_STYLE = {
  Received: "bg-slate-100 text-slate-700",
  "In Prepress": "bg-blue-50 text-blue-700 border border-blue-200",
  "Strike-off": "bg-violet-50 text-violet-700 border border-violet-200",
  "Pending Approval": "bg-amber-50 text-amber-700 border border-amber-200",
  Approved: "bg-teal-50 text-teal-700 border border-teal-200",
  Locked: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Rejected: "bg-rose-50 text-rose-700 border border-rose-200",
};
export const VERSION_STATUS_STYLE = ART_STATUS_STYLE;
